import React from 'react';
import { EchartsWithTheme, useTheme } from '@maxtropy/components';
import styles from './index.module.scss';

interface ChartBlockProps {
  title?: string;
  option: object;
  height?: number;
}

const ChartBlock: React.FC<ChartBlockProps> = ({ title, option, height }) => {
  const theme = useTheme();

  return (
    <div className={styles.chartBlock}>
      {title && <div className={styles.chartTitle}>{title}</div>}
      <EchartsWithTheme option={option} theme={theme} style={{ width: '100%', height }} />
    </div>
  );
};

export default ChartBlock;
